<template>
  <div class="guide-step-2-container" v-if="isVisible">
    <!-- 半透明遮罩（點擊關閉） -->
    <div class="guide-overlay" @click="closeGuide"></div>

    <!-- 步驟提示文字 -->
    <div class="guide-steps-hint">
      <!-- 關閉按鈕 -->
      <button class="close-button" @click="closeGuide">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15 5L5 15M5 5L15 15" stroke="#666" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>

      <div class="step-item">{{ t('gameActManager.gameActGuide.step2.hint1') }}</div>
      <div class="step-item">{{ t('gameActManager.gameActGuide.step2.hint2') }}</div>
      <div class="step-item">{{ t('gameActManager.gameActGuide.step2.hint3') }}</div>
    </div>

    <!-- 返回按鈕引導箭頭 -->
    <div class="guide-back-button">
      <div class="guide-arrow-up">
        <svg width="24" height="40" viewBox="0 0 24 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 2L12 38M12 2L2 12M12 2L22 12" stroke="#F59E0B" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <div class="guide-tip">
        {{ t('gameActManager.gameActGuide.step2.backButton') }}
      </div>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable no-undef */
import { ref, onMounted, defineExpose, defineProps } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

// Props - 接收活動數量
const props = defineProps({
  activityCount: {
    type: Number,
    default: 0
  }
});

const isVisible = ref(false);

// 檢查是否需要顯示引導
const checkGuideStatus = () => {
  const guideStep = localStorage.getItem('hasSeenGameActivityGuideStep');
  // 如果完成了步驟1，但未完成步驟2，且活動數量 ≤ 1，則顯示
  if (guideStep === 'step1' && props.activityCount <= 1) {
    isVisible.value = true;
  }
};

// 隱藏引導（當使用者點擊「返回」按鈕時調用）
const hideGuide = () => {
  isVisible.value = false;
  // 記錄使用者已看過步驟 2
  localStorage.setItem('hasSeenGameActivityGuideStep', 'step2');
};

// 關閉引導（點擊遮罩關閉）
const closeGuide = () => {
  isVisible.value = false;
  // 記錄使用者已看過步驟 2
  localStorage.setItem('hasSeenGameActivityGuideStep', 'step2');
};

// 暴露方法給父組件使用
defineExpose({
  hideGuide
});

onMounted(() => {
  checkGuideStatus();
});
</script>

<style lang="less" scoped>
.guide-step-2-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  pointer-events: auto; // 允許接收點擊事件
}

.guide-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  animation: fade-in 0.3s ease-out;
  cursor: pointer; // 顯示可點擊游標
}

.guide-steps-hint {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(255, 255, 255, 0.98);
  padding: 24px 32px;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  animation: fade-in 0.3s ease-out;
  max-width: 500px;
  position: relative;

  .close-button {
    position: absolute;
    top: 12px;
    right: 12px;
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    transition: background-color 0.2s;

    &:hover {
      background-color: rgba(0, 0, 0, 0.05);
    }

    svg {
      display: block;
    }
  }

  .step-item {
    font-size: 15px;
    font-weight: 500;
    color: #262626;
    line-height: 2;
  }
}

.guide-back-button {
  position: absolute;
  top: 60px;
  left: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  animation: fade-in 0.3s ease-out 0.5s;
  animation-fill-mode: both;
}

.guide-arrow-up {
  svg {
    animation: bounce-vertical 1.5s ease-in-out infinite;
  }
}

.guide-tip {
  background-color: rgba(255, 255, 255, 0.95);
  padding: 10px 16px;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  font-size: 14px;
  font-weight: 600;
  color: #262626;
  line-height: 1.6;
  white-space: nowrap;
  text-align: center;
}

// 動畫定義
@keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes bounce-vertical {
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-8px);
  }
}

// 響應式設計
@media (max-width: 768px) {
  .guide-back-button {
    top: 40px;
    left: 10px;
  }

  .guide-tip {
    font-size: 13px;
    padding: 8px 12px;
  }
}
</style>
